import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useLayoutEffect, useState } from 'react';

import { useQuerySubgrupos } from 'pages/financeiro/dre/configuracao/hooks/subgrupos/useQuerySubgrupos';
import { useQueryGrupos } from 'pages/financeiro/dre/configuracao/hooks/useQueryGrupos';
import { DreGrupo, DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export type DreConfigContext = {
    grupos: DreGrupo[];
    setGrupos: Dispatch<SetStateAction<DreGrupo[]>>;
    subgrupos: DreSubgrupo[];
    setSubgrupos: Dispatch<SetStateAction<DreSubgrupo[]>>;

    activeGrupo: DreGrupo | null;
    setActiveGrupo: Dispatch<SetStateAction<DreGrupo | null>>;
    activeSubgrupo: DreSubgrupo | null;
    setActiveSubgrupo: Dispatch<SetStateAction<DreSubgrupo | null>>;

    isFetchingGrupos: boolean;
    isFetchingSubgrupos: boolean;
};

const DreConfigContext = createContext<DreConfigContext>({} as DreConfigContext);

export function DreConfigProvider({ children }: { children?: ReactNode }) {
    const [grupos, setGrupos] = useState<DreGrupo[]>([]);
    const [subgrupos, setSubgrupos] = useState<DreSubgrupo[]>([]);

    const [activeGrupo, setActiveGrupo] = useState<DreGrupo | null>(null);
    const [activeSubgrupo, setActiveSubgrupo] = useState<DreSubgrupo | null>(null);

    const { data: gruposData, isFetching: isFetchingGrupos } = useQueryGrupos();
    const { data: subgruposData, isFetching: isFetchingSubgrupos } = useQuerySubgrupos({
        grupo: activeGrupo,
    });

    useLayoutEffect(() => {
        if (gruposData) {
            setGrupos(gruposData);
            setActiveGrupo(gruposData[0]);
        }
    }, [gruposData]);

    useLayoutEffect(() => {
        if (subgruposData) {
            setSubgrupos(subgruposData.filter((subgrupo) => subgrupo.fgAtivo));
        }
    }, [subgruposData]);

    return (
        <DreConfigContext.Provider
            value={{
                grupos,
                setGrupos,
                activeGrupo,
                setActiveGrupo,
                subgrupos,
                setSubgrupos,
                isFetchingGrupos,
                isFetchingSubgrupos,
                activeSubgrupo,
                setActiveSubgrupo,
            }}
        >
            {children}
        </DreConfigContext.Provider>
    );
}

export const useDreConfigContext = (): DreConfigContext => useContext(DreConfigContext);
